import { render, staticRenderFns } from "./order-stock-confirm-input.vue?vue&type=template&id=805845ba&scoped=true&"
import script from "./order-stock-confirm-input.vue?vue&type=script&lang=js&"
export * from "./order-stock-confirm-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805845ba",
  null
  
)

export default component.exports